import styled from '@emotion/styled';
import { Theme } from '@mui/material/styles';

export const StyledIconWrapper = styled.div<{ theme?: Theme }>`
  padding: 10px;
  border-radius: 8px;
  height: 44px;
  width: 44px;
  cursor: pointer;
  transition:
    background 0.3s,
    stroke-color 0.3s;

  --stroke-color: ${({ theme }) => theme.palette.customSecondary.primary.foreground};

  &:hover {
    background: ${({ theme }) => theme.palette.customSecondary.primary.hover}1a;
    --stroke-color: ${({ theme }) => theme.palette.customSecondary.primary.subtle};
  }
`;
